import './WarningIconBadge.scss';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

interface IProps {
  label?: string;
  title?: string;
}

export const WarningIconBadge = observer(
  (props: IProps): ReactElement => (
    <span
      className='icon-badge'
      title={props.title}
    >
      <FontAwesomeIcon icon={faExclamationTriangle} />
      {props.label}
    </span>
  )
);
